// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"d2ad5763","703":"baf8f79e"}[chunkId] + ".chunk.js";
};